import React from 'react';

import HomeCardPlaceHolder from '../Homecard/HomeCardPlaceHolder';

const EMPTY_LIST_LENGTH = 8;

const EmptyList = () => (
  <div className="l-list" style={{ margin: 0 }}>
    {new Array(EMPTY_LIST_LENGTH).fill(
      <div className="l-list__item">
        <HomeCardPlaceHolder />
      </div>
    )}
  </div>
);

export default EmptyList;
